import Table from '../objects/Table';
import ShapeDrawingBrush, {
  type CreateObjectOptions,
} from './ShapeDrawingBrush';

const DEFAULT_WIDTH = 750;
const DEFAULT_HEIGHT = 450;

// Brush for drawing frame objects.
class TableDrawingBrush extends ShapeDrawingBrush {
  _createObject(options: CreateObjectOptions, drawing: boolean) {
    const controller = this.canvas.controller;
    let width = DEFAULT_WIDTH;
    let height = DEFAULT_HEIGHT;

    if (drawing) {
      width *= 0.05;
      height *= 0.05;
    }

    const table = new Table({
      controller,
      ...controller.defaultsManager.for('table'),
      ...options,
      textContent: `Table ${this.countTables() + 1}`,
      width,
      height,
    });
    return controller.addToCanvas(table);
  }

  private countTables() {
    return this.canvas.getObjects().filter(obj => obj.type === 'table').length;
  }
}

export default TableDrawingBrush;
